export const en = {
  nav: {
    home: "Home",
    activities: "Our Activities",
    sectors: "Your Professions",
    workflows: "Workflows",
    faq: "FAQ",
    louise: "LouiseTrinitIA",
    contact: "Contact",
    cta: "Start a Project"
  },
  hero: {
    badge: "Intelligence Architecture Expertise",
    title1: "Your",
    title2: "Time",
    title3: "Our Expertise",
    description: "PEXADIA deploys high-performance autonomous systems to buy back your time. Delegate your time-consuming tasks to focus on what matters.",
    cta1: "Buy Back My Hours",
    cta2: "Explore Systems",
    stats: {
      productivity: "Productivity Gain",
      hours: "Hours Freed / year",
      infrastructure: "Infrastructure",
      roi: "Operational ROI"
    }
  },
  timeImpact: {
    badge: "Compared Performance",
    title1: "The",
    title2: "Delta",
    title3: "Pexadia",
    description: "The mathematical measure of your competitive advantage. Don't work harder, work smarter.",
    table: {
      indicator: "Indicator",
      traditional: "Traditional",
      pexadia: "Pexadia Ecosystem",
      impact: "Impact"
    },
    metrics: [
      {
        indicator: "Workflow Management",
        traditional: "15-20 hours / week",
        pexadia: "15 minutes / week",
        impact: "98%"
      },
      {
        indicator: "Visual & Content Creation",
        traditional: "3-5 days lead time",
        pexadia: "Instant (On-demand)",
        impact: "x50"
      },
      {
        indicator: "Accuracy & Human Error",
        traditional: "12% error rate",
        pexadia: "0.02% (Deterministic)",
        impact: "-99%"
      },
      {
        indicator: "Operational Scalability",
        traditional: "Linear hiring",
        pexadia: "Total Elasticity ∞",
        impact: "Exponential"
      }
    ]
  },
  services: {
    badge: "Universal Solutions",
    title1: "Technological",
    title2: "Excellence",
    description: "Our pillars of expertise to transform every aspect of your structure and buy back your time.",
    items: [
      {
        title: "AI Automation",
        desc: "Free up your time by delegating repetitive tasks to our intelligent agents.",
        features: [
          "Autonomous workflows",
          "Advanced API integration",
          "Predictive data analysis"
        ]
      },
      {
        title: "Visual Creation",
        desc: "Stunning visuals generated by the world's best diffusion models.",
        features: [
          "Generative branding",
          "Advertising assets",
          "AI video animation"
        ]
      },
      {
        title: "Web 3.0 Development",
        desc: "Modern, ultra-fast websites natively equipped with AI capabilities.",
        features: [
          "React & Next.js experts",
          "Future-proof UI/UX",
          "Direct LLM integration"
        ]
      },
      {
        title: "Strategy & Consulting",
        desc: "We support you in your company's technological transition.",
        features: [
          "Process audit",
          "AI team training",
          "Data architecture"
        ]
      }
    ]
  },
  sectors: {
    badge: "Sectorial Impact",
    title1: "AI for Your",
    title2: "Professions",
    description: "We don't apply generic solutions. We buy back your time by automating the very heart of your profession.",
    items: [
      {
        role: "Artisans & Construction",
        gain: "€1,150 / month",
        task: "QUOTES & INVOICING",
        detail: "Transform your paperwork evenings into billable hours. AI generates your quotes and measurements in 2 minutes: you gain 12h of production per month."
      },
      {
        role: "Notaries & Lawyers",
        gain: "€2,400 / month",
        task: "CASE ANALYSIS",
        detail: "Divide your legal reading time by 4. Automated analysis of thousands of pages secures your cases and frees up time for your high-value-added advice."
      },
      {
        role: "Real Estate Agents",
        gain: "€1,850 / month",
        task: "BUYER MATCHING",
        detail: "Don't let any prospect slip away. Automatic qualification and multilingual listing creation in one click to increase your mandate volume effortlessly."
      },
      {
        role: "E-commerce",
        gain: "€3,200 / month",
        task: "LISTINGS & SUPPORT",
        detail: "Reduce your support costs by 80%. Our AI handles disputes and stock updates in real-time, acting like a team of 3 people 24/7."
      },
      {
        role: "Healthcare & Practices",
        gain: "€950 / month",
        task: "REPORTS",
        detail: "Eliminate time-consuming administrative tasks. Your reports are dictated and structured instantly, allowing you to see 2 more patients per day."
      },
      {
        role: "HR & Recruitment",
        gain: "€2,100 / month",
        task: "SOURCING & SCREENING",
        detail: "Cut your hiring costs in half. AI-powered video pre-interviews and predictive sourcing allow you to sign the best talent before your competitors."
      },
      {
        role: "Accountants",
        gain: "€1,600 / month",
        task: "DATA ENTRY & AUDIT",
        detail: "Eradicate human error and manual entry. AI detects tax anomalies instantly, transforming your practice into a technological excellence center."
      },
      {
        role: "Hospitality",
        gain: "€1,300 / month",
        task: "AI CONCIERGE",
        detail: "Boost your direct bookings. AI concierge responds in 12 languages and converts inquiries into immediate sales, without commission for third-party platforms."
      }
    ],
    notListed: {
      title: "Your profession is not listed?",
      description: "Our expertise is universal. We analyze your critical processes and create the AI agent capable of absorbing them, whatever your field.",
      cta: "Personalized Profession Audit"
    },
    cta: "Request Case Study",
    impact: "GAIN"
  },
  workflows: {
    badge: "Neural Architecture v3.0",
    title1: "Engineering",
    title2: "Success",
    description: "We don't tinker with tools. We build rigorously orchestrated industrial intelligence infrastructures.",
    ingress: "01 / INGRESS",
    core: "THE NEURAL CORE",
    egress: "03 / EGRESS",
    ingressItems: [
      {
        title: "Omni-Channel Trigger",
        metric: "LATENCY: 1.2MS",
        desc: "Data capture via API, Webhooks & cutting-edge Scrapers for continuous ingestion."
      },
      {
        title: "Identity Verification",
        metric: "SEC_PROTOCOL: TLS 1.3",
        desc: "Rigorous validation, authentication and filtering of each incoming request."
      },
      {
        title: "Data Normalization",
        metric: "FORMAT: JSON/PROTOBUF",
        desc: "Automatic standardization of disparate data flows into exploitable structures."
      }
    ],
    coreItem: {
      title: "PEX-ENGINE V4",
      subtitle: "Proprietary Engine",
      desc: "Our proprietary engine orchestrates the most advanced language models, manages long-term contextual memory and makes autonomous decisions.",
      speed: "SPEED",
      speedValue: "180 t/s",
      confidence: "CONFIDENCE",
      confidenceValue: "99.89"
    },
    egressItems: [
      {
        title: "Execution & Delivery",
        metric: "ACTION: AUTO-EXEC",
        desc: "Automatic triggering of business actions: emails, reports, or ERP orders."
      },
      {
        title: "UI/UX Sync",
        metric: "SYNC: REAL-TIME",
        desc: "Instant synchronization of user interfaces for a reactive experience."
      },
      {
        title: "ERP Integration",
        metric: "DB_STATUS: COMMITTED",
        desc: "Consolidation of results directly into your secured databases."
      }
    ],
    footer: {
      title1: "Your infrastructure,",
      title2: "reinvented.",
      description: "Forget fragile integrations. Pexadia deploys industrial systems designed for raw performance and absolute reliability.",
      cta: "Audit My Processes"
    }
  },
  faq: {
    badge: "Customer Support",
    title1: "Frequently Asked",
    title2: "Questions",
    description: "Everything you need to know about our solutions and our engineering methodology.",
    items: [
      {
        question: "How does Pexadia automation work?",
        answer: "Pexadia deploys autonomous systems that capture your data, process it through our proprietary AI engine, and automatically execute your business actions. Everything is orchestrated without manual intervention."
      },
      {
        question: "What types of processes can be automated?",
        answer: "Almost all: document management, data analysis, content generation, interface synchronization, ERP integrations, customer support, and much more depending on your sector."
      },
      {
        question: "How long does implementation take?",
        answer: "The initial audit takes 24-48h. Full deployment varies according to complexity, generally between 2 to 6 weeks for a complete infrastructure."
      },
      {
        question: "What is the security of my data?",
        answer: "Tier-1 infrastructure with end-to-end encryption, GDPR compliance, and secured databases. Your data never leaves your controlled environment."
      }
    ]
  },
  contact: {
    badge: "Project Initiation",
    title1: "Let's talk about your",
    title2: "Future",
    description: "Have an innovative project or want to automate your business? Our engineers will get back to you within 24h.",
    emailLabel: "Direct Email",
    locationLabel: "Operational HQ",
    location: "Paris, Dubai",
    form: {
      name: "Full name",
      email: "Pro email",
      message: "Project details",
      placeholderName: "John Doe",
      placeholderEmail: "john@company.com",
      placeholderMessage: "How can we optimize your time?",
      cta: "Initialize Transmission",
      success: "Transmission Successful",
      successDesc: "A Pexadia expert will contact you within 24h.",
      another: "Send another message"
    }
  },
  louise: {
    badge: "AI Model",
    title: "LouiseTrinitIA",
    description: "Discover Louise, our revolutionary AI model. A digital creation that pushes the boundaries of artificial intelligence and visual creativity.",
    gallery: {
      title: "Photo Gallery"
    },
    comments: {
      title: "TikTok Comments"
    }
  },
  footer: {
    description: "Pioneers of artificial intelligence applied to business. We create autonomous systems that will define tomorrow's market.",
    nav: "Navigation",
    legal: "Legal",
    rights: "PEXADIA Intelligence Agency. All rights reserved."
  }
};

